/**
 * Color utility functions for manipulating colors
 */

/**
 * Get a darker shade of a color
 * @param {string} hex - The hex color code (with or without #)
 * @param {number} percent - The percentage to darken (0-100)
 * @returns {string} The darkened color as hex
 */
export function getDarkerColor(hex, percent) {
    // Remove the hash if it exists
    hex = hex.replace('#', '')

    // Parse the hex values
    let r = parseInt(hex.substring(0, 2), 16)
    let g = parseInt(hex.substring(2, 4), 16)
    let b = parseInt(hex.substring(4, 6), 16)

    // Calculate darker values
    r = Math.max(0, Math.floor((r * (100 - percent)) / 100))
    g = Math.max(0, Math.floor((g * (100 - percent)) / 100))
    b = Math.max(0, Math.floor((b * (100 - percent)) / 100))

    // Convert back to hex
    return '#' + componentToHex(r) + componentToHex(g) + componentToHex(b)
}

/**
 * Get a lighter shade of a color
 * @param {string} hex - The hex color code (with or without #)
 * @param {number} percent - The percentage to lighten (0-100)
 * @returns {string} The lightened color as hex
 */
export function getLighterColor(hex, percent) {
    // Remove the hash if it exists
    hex = hex.replace('#', '')

    // Parse the hex values
    let r = parseInt(hex.substring(0, 2), 16)
    let g = parseInt(hex.substring(2, 4), 16)
    let b = parseInt(hex.substring(4, 6), 16)

    // Calculate lighter values
    r = Math.min(255, Math.floor(r + (255 - r) * (percent / 100)))
    g = Math.min(255, Math.floor(g + (255 - g) * (percent / 100)))
    b = Math.min(255, Math.floor(b + (255 - b) * (percent / 100)))

    // Convert back to hex
    return '#' + componentToHex(r) + componentToHex(g) + componentToHex(b)
}

/**
 * Helper to convert a component to hex
 * @param {number} c - The color component (0-255)
 * @returns {string} The hex representation
 */
function componentToHex(c) {
    const hex = c.toString(16)
    return hex.length === 1 ? '0' + hex : hex
}
